import {
	Component,
	EventEmitter,
	Input,
	OnDestroy,
	OnInit,
	Output,
	SimpleChanges
} from '@angular/core';
import { Subject } from 'rxjs';
import {
	debounceTime,
	filter,
	finalize,
	map,
	takeUntil,
	tap
} from 'rxjs/operators';
import { JobsDataServiceProvider } from '@services/job/jobs.data.service';
import { EmailAutocomplete } from '@models/models';
import { EmailServiceProvider } from '@services/email/email-service/email.service';

@Component({
	selector: 'email-field',
	template: require('./email-field.component.html'),
	styles: [require('./email-field.component.scss')]
})
export class EmailFieldComponent implements OnInit, OnDestroy {
	@Input() value: Array<string>;
	@Input() disabled: boolean;
	@Input() placeholder: string;
	@Output()
	valueChange: EventEmitter<Array<string> | string> = new EventEmitter();

	multiselectValue: Array<string>;
	isLoading: boolean;
	autocomplete$: Subject<string> = new Subject<string>();
	autocompleteValues: Array<EmailAutocomplete> = [];
	private unsubscribe: Subject<void> = new Subject<void>();

	constructor(
		private jobDataService: JobsDataServiceProvider,
		private emailService: EmailServiceProvider
	) {}

	ngOnInit(): void {
		this.listenToFieldTyping();
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (
			changes.value &&
			!changes.value.isFirstChange() &&
			changes.value.currentValue
		) {
			this.clearAutocomplete();
		}
	}

	ngOnDestroy(): void {
		this.unsubscribe.next();
		this.unsubscribe.complete();
	}

	valueChanges(value: Array<string>): void {
		this.valueChange.emit(value);
	}

	listenToFieldTyping(): void {
		this.autocomplete$
			.asObservable()
			.pipe(
				takeUntil(this.unsubscribe),
				tap((val: string): void => {
					if (val && val.length <= 2) {
						this.clearAutocomplete();
					}
				}),
				map((val: string): string => val.trim()),
				filter((val: string): boolean => val && val.length > 2),
				debounceTime(250)
			)
			.subscribe((data: string): void => this.loadSuggestedData(data));
	}

	loadSuggestedData(field: string): void {
		this.isLoading = true;
		this.jobDataService
			.searchClient(field)
			.pipe(
				takeUntil(this.unsubscribe),
				map((data: Array<EmailAutocomplete>): Array<EmailAutocomplete> =>
					this.emailService.filterEmailAutocomplete(data, this.value)
				),
				finalize((): boolean => (this.isLoading = false))
			)
			.subscribe((data: Array<EmailAutocomplete>): void => {
				this.autocompleteValues = [...data];
			});
	}

	private clearAutocomplete(): void {
		this.autocompleteValues = [];
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/common/email-field/email-field.component.ts